exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@keyframes socialShareAnimation {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.socialShareContainer .socialShareButton {\n  height: 50px;\n  line-height: 50px;\n  padding: 0px 25px;\n  background: #666;\n  color: #fff;\n  cursor: pointer; }\n\n.socialShareContainer .closeShare {\n  display: none;\n  opacity: 0; }\n\n.socialShareContainer .openShare {\n  display: block;\n  opacity: 1;\n  animation: socialShareAnimation 1s; }\n\n.socialShareContainer i {\n  font-size: 16px;\n  margin: 0px 10px;\n  height: 30px; }\n", ""]);

// exports
